const RATES: string[] = [
    'Raty',
    '/Raty/',
    'Raty0%',
    'Raty 0%',
    'Raty 0 %',
    '/Raty0%/',
    '/Raty 0%/',
    '/Raty 0 %/'
];

export function isProductRateZero(str: string): boolean {
    const lowerCase = str.toLowerCase();

    for (const text of RATES) {
        if (lowerCase.includes(text.toLowerCase())) {
            return true;
        }
    }

    return false;
}
